var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{staticClass:"vdp-axis",style:({
            'height': this.computedHeight + 'px', 
            'width': this.computedWidth + 'px',
            'top': this.computedTop + 'px',
            'left': this.computedLeft + 'px'
        }),attrs:{"id":this.axisElemID}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.highlightX !== null && this.highlightY != null),expression:"this.highlightX !== null && this.highlightY != null"}],staticClass:"vdp-axis-highlight",style:({
            'position': 'absolute',
            'pointer-events': 'none',
            'height': '14px', 
            'width': '14px',
            'border-radius': '50%',
            'opacity': 0.6,
            'background-color': '#555',
            'top': (this.computedTop + this.highlightY - 7) + 'px',
            'left': (this.computedLeft + this.highlightX - 7) + 'px'
        })})])}
var staticRenderFns = []

export { render, staticRenderFns }